const FAMILIES: Readonly<Record<string, readonly string[]>> = {
  nx_reason_not_covered: ['not-covered', 'ar001', 'service-not-covered'],
  nx_reason_excluded: ['excluded'],
  nx_reason_limit_exceeded: ['limit-exceeded', 'ar002', 'limit-reached', 'plan-limit-reached', 'benefit-limit-reached', 'annual-limit-reached'],
  nx_reason_duplicate: ['duplicate', 'duplicate-claim', 'duplicate-request', 'duplicate-service'],
  nx_reason_preauth_required: ['pre-auth-required', 'preauth-required', 'pre-authorization-required', 'pre-authorisation-required', 'prior-authorization-required', 'authorization-required'],
  nx_reason_not_eligible: ['not-eligible', 'ineligible'],
  nx_reason_missing_information: ['missing-information', 'missing-info', 'information-missing'],
  nx_reason_identifier_missing: ['a001'],
  nx_reason_provider_identifier_missing: ['a002'],
  nx_reason_service_not_on_plan: ['service-not-on-plan', 'not-in-plan'],
  nx_reason_documents_missing: ['missing-documents', 'missing-attachment', 'attachment-required'],
  nx_reason_expired: ['expired'],
  nx_reason_policy_expired: ['policy-expired', 'coverage-expired'],
  nx_reason_approval_expired: ['approval-expired', 'authorization-expired', 'authorisation-expired', 'pre-authorization-expired'],
  nx_reason_member_not_found: ['member-not-found', 'patient-not-found', 'subscriber-not-found'],
  nx_reason_policy_inactive: ['policy-inactive', 'inactive-policy', 'coverage-not-active', 'not-in-force'],
  nx_reason_out_of_network: ['out-of-network', 'provider-out-of-network'],
  nx_reason_not_medically_necessary: ['not-medically-necessary', 'medical-necessity'],
  nx_reason_waiting_period: ['waiting-period'],
  nx_reason_late_submission: ['late-submission', 'timely-filing'],
  nx_reason_pre_existing: ['pre-existing-condition'],
  nx_reason_quantity_exceeded: ['quantity-exceeded', 'frequency-exceeded'],
  nx_reason_invalid_code: ['invalid-code', 'invalid-service-code', 'invalid-diagnosis-code'],
};

export const REASON_KEYS: Readonly<Record<string, string>> = Object.fromEntries(
  Object.entries(FAMILIES).flatMap(([key, codes]) => codes.map((code) => [code, key] as const)),
);

export const REASON_MESSAGE_KEYS: readonly string[] = Object.keys(FAMILIES);

export function normaliseReasonCode(code: string): string {
  return code.trim().toLowerCase().replace(/[\s_]+/g, '-');
}
